import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from '@shared';

import { BarChartComponent } from './components/bar-chart/bar-chart.component';
import { DeliveryStatisticsComponent } from './containers/delivery-statistics/delivery-statistics.component';
import { StatisticsTableComponent } from './components/statistics-table/statistics-table.component';
import { JumpstoryStatisticsComponent } from './containers/jumpstory-statistics/jumpstory-statistics.component';
import { JumpstoryStatisticsTableComponent } from './components/jumpstory-statistics-table/jumpstory-statistics-table.component';
import { DoughnutChartComponent } from './components/doughnut-chart/doughnut-chart.component';

import { services } from './services';
import { effects } from './effects';
import { reducers } from './reducers';

@NgModule({
  declarations: [
    BarChartComponent,
    DeliveryStatisticsComponent,
    StatisticsTableComponent,
    JumpstoryStatisticsComponent,
    JumpstoryStatisticsTableComponent,
    DoughnutChartComponent,
  ],
  imports: [
    CommonModule,
    NgbModule,
    EffectsModule.forFeature(effects),
    SharedModule,
    ReactiveFormsModule,
    StoreModule.forFeature('Statistics', reducers),
  ],
  providers: [...services],
})
export class DeliveryStatisticsModule {}
